import React, { useEffect, useState } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Collapse,
  TextField,
  Autocomplete,
  Checkbox,
  Avatar,
  Tooltip,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
  Typography,
  IconButton,
  Paper,
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
} from "@mui/material";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { Modal, Offcanvas } from "react-bootstrap";
import { IoIosArrowBack } from "react-icons/io";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useTheme } from "../../ThemeContext";
import { width } from "@mui/system";
import { OffcanvasBody } from "react-bootstrap";

import {
  Filter,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@mui/icons-material";

import { toast } from "react-toastify";

// import * as React from 'react';
import clsx from "clsx";
import { styled, css } from "@mui/system";
import { Modal as BaseModal } from "@mui/material";
// import WeekPicker from "./WeeckPicker";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {
  DatePicker,
  LocalizationProvider,
  MonthCalendar,
  StaticDatePicker,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
// import Loader from "../common/Loader";
import { DateRangePicker } from "react-date-range";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { filterEntities, getAllData, postdatas } from "../../apis/apiService";
import { positiveNumberRule } from "../../utils/amount";
import {
  useFetchBudgetPaymentsQuery,
  useFetchBudgetSummaryTableQuery,
  useFetchDeleteRatePerHourMutation,
  useFetchGetallUserListQuery,
  useFetchRatePerHourQuery,
  useFetchUpdateRatePerHourMutation,
} from "../../slice/logdetailSlice";
import {
  preventNegativeValues,
  blockNonDigitKeys,
  validateEndDate,
} from "../../components/common/PreventValidate";
import { format } from "date-fns";
import Loader from "../../components/common/Loader";
import { CiFilter } from "react-icons/ci";
import { FaDeleteLeft } from "react-icons/fa6";
import { FaEdit, FaRegEdit, FaTrash } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import SearchBar from "../../components/SearchBar";
// import { Button } from '@mui/base/Button';
export const AddPaymentComponent = ({ onapply, oncancel, onTableRefetch }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  const { name, id: login_user_id } = loginUser;
  const { data, refetch: rate_per_hour_refetch } = useFetchRatePerHourQuery();
  const { data: usersInProjects } = useFetchGetallUserListQuery();
  // //console.log()("usersInProjects :", usersInProjects);

  const extractedUsers = usersInProjects
    ? usersInProjects.map((userWrapper) => userWrapper)
    : [];

  // //console.log()("usersInProjects extractedUsers:", extractedUsers);

  const [selectedUser, setSelectedUser] = useState(login_user_id);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
    register,
  } = useForm({
    defaultValues: {
      //   TaskName: "",
      startDate: null,
      endDate: null,
      //   defaultDescription: "",
      //   owner: login_user_id,
      //   billingType: "",
      WorkHours: "",
      //   Priority: "",
      //   uploadedFile: null,
      owner_id: null,
      seatCharge: null,
      //   TaskList: "",
    },
  });

  const onSubmit = async (data) => {
    const requestData = {
      //   title: data.TaskName,
      start_date: data.startDate
        ? format(new Date(data.startDate), "yyyy-MM-dd")
        : null,
      end_date: data.endDate
        ? format(new Date(data.endDate), "yyyy-MM-dd")
        : null,
      //   description: data.defaultDescription,
      user_id: data.owner_id,
      per_hr_rate: data.WorkHours,
      without_seat_charge: data.seatCharge,
    };
    // //console.log()("data_user:", data);

    setIsSubmitting(true);
    try {
      // Call your API or logic to create the task
      const response = await postdatas("ratePerHour", "add", requestData);
      toast.success(response.message);
      reset();
      oncancel();
      onTableRefetch();
      rate_per_hour_refetch();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={oncancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Add Rate per Hour
          </div>
        </button>
      </div>
      <div className="bg-white px-4 pb-5 pt-3 overflow-scroll">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              {/* Owner Field */}
              <div className="row mb-3">
                <div className="col-md-12 mt-3">
                  <label htmlFor="owner_id" className="form-label">
                    Select User <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    name="owner_id"
                    control={control}
                    rules={{ required: "User field is required" }}
                    render={({
                      field: { onChange, value },
                      formState: { errors },
                    }) => (
                      <>
                        <Autocomplete
                          id="owner_id"
                          options={extractedUsers}
                          getOptionLabel={(option) => option.name}
                          value={
                            extractedUsers?.find(
                              (user) => user.user_id === value
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            if (newValue) {
                              if (Array.isArray(newValue)) {
                                toast.error("You can select only one user.");
                              } else {
                                onChange(newValue.user_id);
                              }
                            } else {
                              onChange(null);
                            }
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.name}</strong>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select user" />
                          )}
                        />
                        <span className="errorMsg">
                          {errors?.owner_id?.message}
                        </span>
                      </>
                    )}
                  />
                </div>
              </div>

              {/* Date Fields */}
              <div className="row paddingBtn mb-3">
                <div className="col-md-6">
                  <label htmlFor="startDate" className="form-label">
                    Start Date <span className="errorMsg">*</span>
                  </label>
                  <div className="d-flex  flex-column w-100">
                    <Controller
                      name="startDate"
                      control={control}
                      rules={{ required: "Start date is required" }}
                      render={({ field, formState: { errors } }) => (
                        <DatePicker
                          {...field}
                          value={field.value}
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      )}
                    />
                    <span className="pickererrorMsg">
                      {errors?.startDate?.message}
                    </span>
                  </div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="endDate" className="form-label">
                    End Date
                    <span className="errorMsg">*</span>
                  </label>
                  <div className="d-flex  flex-column w-100">
                    <Controller
                      name="endDate"
                      control={control}
                      rules={{
                        required: "End date is required",
                      }}
                      render={({ field, formState: { errors } }) => (
                        <DatePicker
                          {...field}
                          value={field.value}
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      )}
                    />
                    <span className="pickererrorMsg">
                      {errors?.endDate?.message}
                    </span>
                  </div>
                </div>

                {/* Other fields */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="WorkHours" className="form-label">
                    Per Hour Rate <span className="errorMsg">*</span>
                  </label>
                  <TextField
                    type="text"
                    id="WorkHours"
                    placeholder="Per hour rate"
                    className="form-control"
                    {...control.register("WorkHours", {
                      validate: positiveNumberRule("Per hour rate"),
                    })}
                    onKeyDown={blockNonDigitKeys}
                    onChange={(event) => {
                      preventNegativeValues(event);
                    }}
                    inputProps={{ maxLength: 5, inputMode: "numeric" }}
                  />
                  <span className="errorMsg">{errors?.WorkHours?.message}</span>
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="WorkHours" className="form-label">
                    Without Seat Charge <span className="errorMsg">*</span>
                  </label>
                  <TextField
                    type="text"
                    id="seatCharge"
                    placeholder="Without seat charge"
                    className="form-control"
                    {...control.register("seatCharge", {
                      validate: positiveNumberRule("Seat charge"),
                    })}
                    onKeyDown={blockNonDigitKeys}
                    onChange={(event) => {
                      preventNegativeValues(event);
                    }}
                    inputProps={{ maxLength: 5, inputMode: "numeric" }}
                  />
                  <span className="errorMsg">
                    {errors?.seatCharge?.message}
                  </span>
                </div>
              </div>

              {/* Submit Buttons */}
              <div className="bg-white position-absolute bottom-0 py-3 w-100">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="me-3 add_btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Adding..." : "Add"}
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={oncancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};
const RateFilterComponent = ({ onapply, oncancel }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  const { name, id: login_user_id } = loginUser;
  const { data, refetch: rate_per_hour_refetch } = useFetchRatePerHourQuery();
  const { data: usersInProjects } = useFetchGetallUserListQuery();
  // //console.log()("usersInProjects :", usersInProjects);

  const extractedUsers = usersInProjects
    ? usersInProjects.map((userWrapper) => userWrapper)
    : [];
  // //console.log()("usersInProjects extractedUsers:", extractedUsers);

  const [selectedUser, setSelectedUser] = useState(login_user_id);
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
    register,
  } = useForm({
    defaultValues: {
      //   TaskName: "",
      startDate: null,
      endDate: null,
      //   defaultDescription: "",
      //   owner: login_user_id,
      //   billingType: "",
      WorkHours: "",
      //   Priority: "",
      //   uploadedFile: null,
      owner_id: [],
      //   TaskList: "",
    },
  });

  const onSubmit = async (data) => {
    //console.log()("update_filter_date :", data);

    const requestData = {
      //   title: data.TaskName,
      from_date: data.startDate
        ? format(new Date(data.startDate), "yyyy-MM-dd")
        : null,
      to_date: data.endDate
        ? format(new Date(data.endDate), "yyyy-MM-dd")
        : null,
      //   description: data.defaultDescription,
      owner_id: data.owner_id,
      // per_hr_rate: data.WorkHours,
    };
    // //console.log()("data_user:", data);

    setIsSubmitting(true);
    try {
      // Call your API or logic to create the task
      const response = await filterEntities("ratePerHour/show", requestData);
      toast.success(response.message);
      reset();
      oncancel();
      // rate_per_hour_refetch();
      onapply(response.data);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={oncancel} className="R_btn">
          <div className="d-flex  text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Filter
          </div>
        </button>
      </div>
      <div className="bg-white px-4 pb-5 pt-3 overflow-scroll">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              {/* Owner Field */}
              <div className="row mb-3">
                <div className="col-md-12 mt-3">
                  <label htmlFor="owner_id" className="form-label">
                    Select User <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    name="owner_id"
                    control={control}
                    rules={{ required: "User field is required" }}
                    render={({
                      field: { onChange, value },
                      formState: { errors },
                    }) => (
                      <>
                        <Autocomplete
                          id="owner_id"
                          multiple
                          options={extractedUsers}
                          getOptionLabel={(option) => option.name}
                          value={extractedUsers.filter((user) =>
                            value?.includes(user.user_id)
                          )} // Match selected users
                          onChange={(event, newValue) => {
                            const selectedIds = newValue.map(
                              (user) => user.user_id
                            );
                            onChange(selectedIds); // Update the form field with an array of user IDs
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.name}</strong>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select users" />
                          )}
                        />
                        <span className="errorMsg">
                          {errors?.owner_id?.message}
                        </span>
                      </>
                    )}
                  />
                </div>
              </div>

              {/* Date Fields */}
              <div className="row paddingBtn mb-3">
                <div className="col-md-6">
                  <label htmlFor="startDate" className="form-label">
                    Start Date
                  </label>
                  <div className=" d-flex flex-column w-100">
                    <Controller
                      name="startDate"
                      control={control}
                      render={({ field, formState: { errors } }) => (
                        <DatePicker
                          {...field}
                          value={field.value}
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="endDate" className="form-label">
                    End Date
                    {/* <span className="errorMsg">*</span> */}
                  </label>
                  <div className=" d-flex w-100 flex-column">
                    <Controller
                      name="endDate"
                      control={control}
                      // rules={{
                      //   required: "End date is required",
                      // }}
                      render={({ field, formState: { errors } }) => (
                        <DatePicker
                          {...field}
                          value={field.value}
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      )}
                    />
                  </div>
                  {/* <span className="errorMsg">{errors?.endDate?.message}</span> */}
                </div>
              </div>

              {/* Submit Buttons */}
              <div className="bg-white position-absolute bottom-0 py-3 w-100">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="me-3 add_btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Adding..." : "Add"}
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={oncancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};
export const BudgetTable = ({
  filteredData,
  transformedData,
  table_refetch,
  login_user_role,
}) => {
  const { isDarkMode } = useTheme();
  //console.log()("API Response data_response :", filteredData);

  // Check if data exists
  // const groupedData = filteredData?.grouped_data || {};
  // const hasData = Object.keys(groupedData).length > 0;
  const groupedData =
    filteredData && Object.keys(filteredData).length > 0
      ? filteredData
      : transformedData.grouped_data;
  // console.log("group_data: ", groupedData);
  
  const hasData = Object.keys(groupedData).length > 0;
  const [updateData, setUpdateData] = useState({});
     const [showPopup, setShowPopup] = useState(false);                                                 
  const {
    handleSubmit,                           
    reset,
    control,
    clearErrors,
    formState: { errors },
  } = useForm();
  const [updateRatePerHourMutation, { isLoading }] =
    useFetchUpdateRatePerHourMutation();
  const [deleteRatePerHourMutation, { isLoading: isDeleting }] =
    useFetchDeleteRatePerHourMutation();

  // Show "No Data Found" if there's no data

  // Transform API data for rendering
  const data = [];
  for (const [id, group] of Object.entries(groupedData)) {
    const { name, rates } = group;

    const rows =
      rates?.details?.length > 0
        ? rates.details.map((detail) => ({
          
            rate: detail.rate || "No Data",
            startDate: detail.start_date || "No Data",
        monthly_ctc: detail.monthly_ctc ?? "No Data", // ✅ FIXED
            without_seat_charge: detail.without_seat_charge || "No Data",
            endDate: detail.end_date || "No Data",
            addedAt: detail.added_at || "No Data", // Display added_at
            addedBy: detail.added_by || "No Data", // Display added_by
            owner_id: detail.owner_id,
            update_id: detail.id,
          }))
 

        : [
            {
              rate: "No Data",
              startDate: "No Data",
              endDate: "No Data",
              addedAt: "No Data",
              addedBy: "No Data",
            },
          ];

    data.push({
      id,
      name: name || "No Data",
      rows,
    });
  }
  const handleRowAction = (actionType, row, group) => {
    setUpdateData({
      type: actionType,
      user_id: row.owner_id,
      end_date: row.endDate,
      start_date: row.startDate,
      update_id: row.update_id,
      rate: row.rate,
      name: group.id,
      without_seat_charge:row.without_seat_charge
    });
    setShowPopup(true);
    // console.log("Action:", actionType); // "edit" or "delete"
    // console.log("Row Details:", row); // Row with rate, dates, etc.
    // console.log("Group Info:", group); // Group with id, name, etc.

    // You can call your update/delete logic here
  };
  // console.log("updated_data :", updateData);

  const updateRatePerHour = async (data) => {
    // console.log("updateRatePerHour :", data);
    const requestedData = {
      user_id: updateData.user_id,
      per_hr_rate: data.rate,
      without_seat_charge: data.without_seat_charge,
      start_date: data.start_date?.isValid?.()
        ? data.start_date.format("YYYY-MM-DD")
        : null,
      end_date: data.end_date?.isValid?.()
        ? data.end_date.format("YYYY-MM-DD")
        : null,
    };

    try {
      const response = await updateRatePerHourMutation({
        data: requestedData,
        id: updateData.update_id,
      }).unwrap();
      if (response) {
        setShowPopup(false);
        toast.success(response?.message || response?.data?.message);
        table_refetch();
      }
    } catch (error) {
      console.error("errormessage :", error);
      toast.error(error?.data?.message || error?.message || "Failed to update rate per hour");
    }
  };
  
  const handleDelete = async () => {
    try {
      const response = await deleteRatePerHourMutation(updateData.update_id);
      toast.success(response?.data?.message || "Deleted successfully");
      setShowPopup(false);
      table_refetch();
    } catch (error) {
      toast.error(error?.data?.message);
    }
  };

  // //console.log()("Transformed Data for Table Rendering:", data);
  useEffect(() => {
    if (updateData?.type === "edit") {
      reset({
        rate: updateData?.rate || "",
        start_date: updateData?.start_date
          ? dayjs(updateData.start_date)
          : null,
        end_date: updateData?.end_date ? dayjs(updateData.end_date) : null,
        without_seat_charge: updateData?.without_seat_charge || "",
      });
      clearErrors();
    }
  }, [updateData, reset, clearErrors]);
  if (!hasData) {
    return (
      <Typography
        variant="h6"
        align="center"
        sx={{ margin: "20px", color: "gray" }}
      >
        No Data Found
      </Typography>
    );
  }

  return (
    <>
      <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
        <Table stickyHeader sx={{ boxShadow: "none", border: "none" }}>
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Rate / hr</TableCell>
              <TableCell>Monthly CTC</TableCell>
              <TableCell>Without Seat Charge</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell>End Date</TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Created At</TableCell>
              {login_user_role === "ADMIN" && <TableCell> Action</TableCell>}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((group, groupIndex) => (
              <React.Fragment key={group.id}>
                {group.rows.map((row, rowIndex) => (
                  <TableRow key={`${group.id}-${rowIndex}`}>
                    {rowIndex === 0 && (
                      <>
                        <TableCell rowSpan={group.rows.length}>
                          {groupIndex + 1}
                        </TableCell>
                        <TableCell rowSpan={group.rows.length}>
                          {group.name}
                        </TableCell>
                      </>
                    )}
                    <TableCell>{row.rate}</TableCell>
                    <TableCell>{row.monthly_ctc}</TableCell>
                    <TableCell>{row.without_seat_charge}</TableCell>
                    <TableCell>{row.startDate}</TableCell>
                    <TableCell>{row.endDate}</TableCell>
                    <TableCell>{row.addedBy}</TableCell>
                    <TableCell>{row.addedAt}</TableCell>
                    {login_user_role === "ADMIN" && (
                      <TableCell>
                        <div className="d-flex align-items-center gap-1">
                          <Tooltip title="Edit" placement="top">
                            <IconButton
                              size="small"
                              onClick={() => handleRowAction("edit", row, group)}
                              sx={{
                                color: isDarkMode ? "#2dd4bf" : "#04a189",
                                padding: "9px",
                                borderRadius: "50%",
                                transition: "all 0.2s ease-in-out",
                                "&:hover": {
                                  backgroundColor: isDarkMode
                                    ? "rgba(4, 161, 137, 0.2)"
                                    : "rgba(4, 161, 137, 0.1)",
                                },
                              }}
                            >
                              <FaRegEdit size={17} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete" placement="top">
                            <IconButton
                              size="small"
                              onClick={() => handleRowAction("delete", row, group)}
                              sx={{
                                color: isDarkMode ? "#f87171" : "#d32f2f",
                                padding: "9px",
                                borderRadius: "50%",
                                transition: "all 0.2s ease-in-out",
                                "&:hover": {
                                  backgroundColor: isDarkMode
                                    ? "rgba(239, 68, 68, 0.2)"
                                    : "rgba(229, 57, 53, 0.1)",
                                },
                              }}
                            >
                              <RiDeleteBin5Line size={17} />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </TableCell>
                    )}
                    {/* New Column */}
                  </TableRow>
                ))}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal show={showPopup} onHide={() => setShowPopup(false)} centered>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {updateData.type === "edit" && (
            <form onSubmit={handleSubmit(updateRatePerHour)}>
              <Modal.Header closeButton closeVariant={isDarkMode ? "white" : undefined}>
                <Modal.Title>Edit Rate Per Hour</Modal.Title> <br />
              </Modal.Header>
              <Modal.Body>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <p>Name : {updateData.name}</p>
                  <div>
                    <label htmlFor="rate" className="form-label">
                      Rate Per Hour <span className="errorMsg">*</span>
                    </label>
                    <Controller
                      name="rate"
                      control={control}
                      rules={{ validate: positiveNumberRule("Per hour rate") }}
                      render={({ field }) => (
                        <TextField
                          fullWidth
                          {...field}
                          placeholder="Per hour rate"
                          inputProps={{ maxLength: 5, inputMode: "numeric" }}
                          onKeyDown={blockNonDigitKeys}
                          onChange={(e) => {
                            preventNegativeValues(e);
                            field.onChange(e.target.value);
                          }}
                          error={Boolean(errors?.rate)}
                        />
                      )}
                    />
                    {errors?.rate && (
                      <span className="errorMsg">{errors.rate.message}</span>
                    )}
                  </div>
                  <div>
                    <label htmlFor="without_seat_charge" className="form-label">
                      Without Seat Charge <span className="errorMsg">*</span>
                    </label>
                    <Controller
                      name="without_seat_charge"
                      control={control}
                      rules={{ validate: positiveNumberRule("Without seat charge") }}
                      render={({ field }) => (
                        <TextField
                          fullWidth
                          {...field}
                          placeholder="Without seat charge"
                          inputProps={{ maxLength: 5, inputMode: "numeric" }}
                          onKeyDown={blockNonDigitKeys}
                          onChange={(e) => {
                            preventNegativeValues(e);
                            field.onChange(e.target.value);
                          }}
                          error={Boolean(errors?.without_seat_charge)}
                        />
                      )}
                    />
                    {errors?.without_seat_charge && (
                      <span className="errorMsg">{errors.without_seat_charge.message}</span>
                    )}
                  </div>
                  <div>
                    <label htmlFor="start_date" className="form-label">
                      Start Date <span className="errorMsg">*</span>
                    </label>
                    <Controller
                      name="start_date"
                      control={control}
                      rules={{
                        required: "Start date is required",
                        validate: (val) =>
                          val && dayjs(val).isValid() ? true : "Valid start date is required",
                      }}
                      render={({ field }) => (
                        <DatePicker
                          value={field.value}
                          onChange={(newValue) => field.onChange(newValue)}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              error: Boolean(errors?.start_date),
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.start_date && (
                      <span className="pickererrorMsg">{errors.start_date.message}</span>
                    )}
                  </div>
                  <div>
                    <label htmlFor="end_date" className="form-label">
                      End Date <span className="errorMsg">*</span>
                    </label>
                    <Controller
                      name="end_date"
                      control={control}
                      rules={{
                        required: "End date is required",
                        validate: (val, formValues) => {
                          if (!val || !dayjs(val).isValid()) {
                            return "Valid end date is required";
                          }
                          if (
                            formValues.start_date &&
                            dayjs(val).isBefore(dayjs(formValues.start_date), "day")
                          ) {
                            return "End date must be after or equal to start date";
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <DatePicker
                          value={field.value}
                          onChange={(newValue) =>
                            field.onChange(newValue ?? null)
                          }
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              error: Boolean(errors?.end_date),
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.end_date && (
                      <span className="pickererrorMsg">{errors.end_date.message}</span>
                    )}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className=" cancel_btn"
                  type="button"
                  disabled={isLoading}
                  onClick={() => setShowPopup(false)}
                >
                  Cancel
                </button>

                <button type="submit" disabled={isLoading} className=" add_btn">
                  Update
                </button>
              </Modal.Footer>
            </form>
          )}
        </LocalizationProvider>
        {updateData.type === "delete" && (
          <>
            <Modal.Header closeButton closeVariant={isDarkMode ? "white" : undefined}>Delete Confirmation</Modal.Header>
            <Modal.Body>
              Are you sure you want to delete this <b>{updateData.name}</b> rate
              entry?
            </Modal.Body>
            <Modal.Footer>
              <button
                className=" cancel_btn"
                onClick={() => setShowPopup(false)}
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                className=" add_btn"
                disabled={isDeleting}
                onClick={handleDelete}
              >
                Delete
              </button>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

const RateperHour = () => {
  const { isDarkMode } = useTheme();
  const {
    handleSubmit,
    control,
    register,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      project_span: "all",
      // from_date: dayjs().format("YYYY-MM-DD"),
      // to_date: dayjs().format("YYYY-MM-DD"),
    },
  });
  const [showfilter, setShowFilter] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState({});
  const [filterBtn, setFilterBtn] = useState(false);
  const [showAddpayment, setShowAddPayment] = useState(false);
  const project_id = localStorage.getItem("project_id");
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // //console.log()("login_user in pproject:", login_user);
  const { role: login_user_role } = login_user;
  // const [loading, setLoading] = useState(false);
  const {
    data: rate_per_hour,
    isLoading,
    refetch: table_refetch,
  } = useFetchRatePerHourQuery({ search: searchTerm });
  //  const {
  //     data: issue_module,
  //     refetch: issue_module_refetch,
  //     isLoading: issue_module_loading,
  //   } = useFetchIssueModuleQuery({
  //     view_type_id: filter,
  //     searchText: searchTerm,
  //   });

  // console.log("rate_per_hour?? : ", rate_per_hour);

  const transformRatePerHourData = (rate_per_hour) => {
    if (!rate_per_hour) return { grouped_data: {} };

    const groupedData = {};

    Object.entries(rate_per_hour).forEach(([userName, rates]) => {
      groupedData[userName] = {
        name: userName,
        rates: {
          details: rates.map((rate) => ({
            rate: rate.per_hr_rate,
            start_date: rate.start_date,
            monthly_ctc:rate.monthly_ctc,
            without_seat_charge: rate.without_seat_charge,
            end_date: rate.end_date,
            added_at: rate.added_at, // New Field
            added_by: rate.added_by, // New Field
            owner_id: rate.owner_id,
            id: rate.id,
          })),
        },
      };
    });

    return { grouped_data: groupedData };
  };
  const handleShowFilter = () => {
    setShowFilter((open) => !open);
  };
  const transformedData = transformRatePerHourData(rate_per_hour);
  const handleFilterApply = (data) => {
    //console.log()("Filter applied, raw data:", data);

    const transformed = transformRatePerHourData(data);
    //console.log()("Transformed data:", transformed);

    setFilteredData(transformed.grouped_data);
    setShowFilter(false);
    setFilterBtn(true);
  };
  const handleClearFilter = () => {
    setFilterBtn(false);
    table_refetch();
    setFilteredData({});
  };
  //console.log()("state variable data_response ", filteredData);
  useEffect(() => {
    table_refetch();
  }, []);

  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value) {
      // await fetchSearchedPortalUsers(value);
    } else {
      //  await FetchPortalUsers();
      // setIssues([]); // Clear projects if search term is empty
    }
  };
  return (
    <>
      {/* ad payment */}
      <Offcanvas placement="end" show={showAddpayment} style={{ width: "50%" }}>
        <Offcanvas.Body className="p-0">
          <AddPaymentComponent
            onClose={() => setShowAddPayment(false)} // Close the Offcanvas
            onapply={() => {
              // //console.log()("Save triggered");
              // setShowAddPayment(false); // Close on apply
            }}
            oncancel={() => {
              // //console.log()("Cancel triggered");
              setShowAddPayment(false); // Close on cancel
            }}
            onTableRefetch={table_refetch}
          />
        </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas placement="end" show={showfilter} style={{ width: "50%" }}>
        <Offcanvas.Body className="p-0">
          <RateFilterComponent
            onClose={() => setShowFilter(false)} // Close the Offcanvas
            onapply={handleFilterApply}
            oncancel={() => {
              // //console.log()("Cancel triggered");
              setShowFilter(false); // Close on cancel
            }}
          />
        </Offcanvas.Body>
      </Offcanvas>
      {/* <div className=" d-flex justify-content-end align-items-center  gap-2">
        <div className=" d-flex align-items-center justify-content-end gap-3 my-3 "> */}
      <Box
        className="d-flex justify-content-end align-items-center mt-3"
        sx={{
          border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "12px 16px",
          marginBottom: "16px",
          backgroundColor: isDarkMode ? "transparent" : "#fff",
        }}
      >
        <div className="d-flex align-items-center justify-content-end gap-3">
          <SearchBar
            placeholder="Search users"
            searchTerm={searchTerm}
            onSearchChange={handleSearchChange}
          />
          {login_user_role === "ADMIN" && (
            // <Tooltip title="Update rate per hour" arrow>
            <Tooltip title="Add rate per hour" arrow>
              <button
                className="show-btn text-capitalize border-0"
                onClick={() => setShowAddPayment((open) => !open)}
              >
                Add
              </button>
            </Tooltip>
          )}
        </div>
        {/* {filterBtn && (
          <button
            type="button"
            disabled={isLoading}
            className=" me-3 addmore_btn"
            onClick={handleClearFilter}
          >
            Clear filter
          </button>
        )} */}
        {/* <div className=" d-flex align-items-center  ">
          <Tooltip title="Filter">
            <button
              className="border-0 p-2 rounded-circle text-decoration-none me-3 project-icon-bg"
              onClick={handleShowFilter}
            >
              <CiFilter className="text-rgbr-blue pro-icon-s" />
            </button>
          </Tooltip>
        </div> 
      </div>
        */}
        </Box>
      <div>
        {/* <button
          className="show-btn text-capitalize border-0"
          onClick={() => setShowAddExpense((open) => !open)}
        >
          add expense
        </button> */}
      </div>

      {/* <button className="budget_dropdown_btn my-4">
        {budgetOpen ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </button> */}
      {/* <Collapse timeout={700} in={budgetOpen}> */}
      {isLoading ? (
        <Loader />
      ) : (
        <BudgetTable
          filteredData={
            Object.keys(filteredData).length > 0
              ? filteredData
              : transformedData.grouped_data
          }
          transformedData={transformedData}
          table_refetch={table_refetch}
          login_user_role={login_user_role}
        />
      )}
      {/* </Collapse> */}
    </>
  );
};

export default RateperHour;
